import React from 'react';

import * as signalmentValues from './../../containers/Signalment/SignalmentValues';
import WeeksLitter from '../../containers/WeeksLitter/WeeksLitter';

/**
 * Signalment Switcher component
 */
const Signalment = (props) => (
  <div className="nppe2-fc-signalment-switcher nppe2-fc-check-box">


    <div className="row">
      <div className="col-md-6">
        <label>
          <input
            name="nppe2-fc-sterilised"
            type="checkbox"
            checked={props.selectedSterilised}
            onChange={(e) => props.onSelectSterilised(e.target.checked)}
            disabled = {(props.greyedSterilised)? "disabled" : ""}
          />
          <div className="nppe2-fc-check-box__label">
            {props.data.data[signalmentValues.STERILISED]}
          </div>
        </label>
      </div>

      <div className="col-md-12">
        <div className="row">

          <div className="col-md-6">
            <div className="nppe2-fc-offset-checkbox">
              <label>
                <input
                  name="nppe2-fc-pregnant"
                  type="checkbox"
                  checked={props.selectedPregnant}
                  onChange={(e) => props.onSelectPregnant(e.target.checked)}
                  disabled = {(props.greyedPregnant)? "disabled" : ""}
                />
                <div className="nppe2-fc-check-box__label">
                  {props.data.data[signalmentValues.PREGNANT]}
                </div>
              </label>
            </div>
          </div>

          <div className="col-md-6">
            <div className="nppe2-fc-offset-checkbox">
              <label>
                <input
                  name="nppe2-fc-lactation"
                  type="checkbox"
                  checked={props.selectedLactation}
                  onChange={(e) => props.onSelectLactation(e.target.checked)}
                  disabled = {(props.greyedLactation)? "disabled" : ""}
                />
                <div className="nppe2-fc-check-box__label nppe2-fc-offset-checkbox">
                  {props.data.data[signalmentValues.LACTATION]}
                </div>
              </label>
            </div>
          </div>

          <div className="col-md-12">
            <WeeksLitter />
          </div>

        </div>
      </div>
    </div>


    

    

    
  </div>
);

export default Signalment;
